module.exports = __webpack_public_path__ + "media/my_images/owner/step3-c13ed21d8cb3b516b5ec401d9dfbbedb.svg";